<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Please click the link to download</h4>
    <button mat-button [mat-dialog-close]="" (click)="close()" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content class="dialog-content">
    <table class="download-dialog">
      <tr>
        <th>No.</th>
        <th>Date</th>
        <th>Type</th>
        <th>Jurisdiction</th>
        <th>Download</th>
      </tr>
      @for (item of filteredData; track item; let i = $index) {
      <tr class="mat-row">
        <td>{{i + 1}}</td>
        <td>{{item.fdate}}</td>
        <td>{{item.ftype}}</td>
        <td>{{item.jurisdiction}}</td>
        <td>
          <a
            href="xcelerator-builds/{{item.fname}}"
            download="{{item.saveAs}}"
            [matTooltip]="item.saveAs"
            matTooltipClass="tooltip2"
            ><mat-icon>download</mat-icon></a
          >
        </td>
      </tr>
      }
    </table>
  </div>
  <div mat-dialog-actions class="right-end">
    <div>
      <button
        mat-button
        (click)="close()"
        mat-dialog-close
        class="button-close"
      >
        Close
      </button>
    </div>
  </div>
</div>
